import { BaseTabsUpdateComponent } from './../base-tabs-update-component';
import { UserService } from './../../base-services/user.service';
import { BaseEntity } from './../../base-models/base-entity';
import { ActivatedRoute } from '@angular/router';
import { BaseContainer } from './base-container';
import { TabsContainerService } from './services/tabs-container.service';
import { ViewChild, OnInit } from '@angular/core';
import { DefaultListTabsComponent } from '../../base-components/default-list/default-list-tabs.component';

export class BaseTabsContainer<T extends BaseEntity> extends BaseContainer<T> implements OnInit {
    constructor(
        protected tabsContainerService: TabsContainerService<T>,
        protected activatedRoute: ActivatedRoute,
        protected userService: UserService
    ){
            super(tabsContainerService, activatedRoute, userService);
    }

    @ViewChild('tabSet', /* TODO: add static flag */ {static: true}) tabSet;
    @ViewChild('fr', /* TODO: add static flag */ {static: true}) fr;
    @ViewChild('tabs-cont', /* TODO: add static flag */ {static: true}) tabsCont;
    @ViewChild('baseTabsUpdate', /* TODO: add static flag */ {static: false}) baseTabsUpdate: BaseTabsUpdateComponent<T>;
    @ViewChild('defaultList', { static: false }) defaultList: DefaultListTabsComponent<any>;

    private logTabFlowDebug(methodName: string, data: any){
        const w = typeof window !== 'undefined' ? (window as any) : null;
        if (!w || w.__TAB_FLOW_DEBUG !== true){
            return;
        }
        console.log('[TAB-FLOW-DEBUG]', methodName, data);
    }

    ngOnInit(){
        super.ngOnInit();
        this.tabsContainerService.ActiveTab.subscribe(activeTab => {
            this.tabSet.select(activeTab);
            // if (activeTab === 'tbList') {
            //     this.tabsContainerService.IsListTabDisabled = false;
            // }

            // this.tabSet.select(activeTab);

            if (activeTab === 'tbList') {
                // this.tabsContainerService.IsUpdateTabDisabled = true;

                const hasMainItems = !!(this.defaultList && this.defaultList.mainItems);
                const selectedItem = hasMainItems ? this.defaultList.mainItems.find(item => item.Selected) : null;
                this.logTabFlowDebug('ActiveTab.tbList', {
                    timestamp: Date.now(),
                    currentTab: activeTab,
                    itemID: selectedItem ? selectedItem.ID : null,
                    idParameter: null,
                    mainItemsExists: hasMainItems,
                    mainItemsCount: hasMainItems ? this.defaultList.mainItems.size : 0,
                    selectedItemExists: !!selectedItem,
                    selectedItemID: selectedItem ? selectedItem.ID : null,
                    refreshType: null,
                    detailListExists: !!(this.defaultList && this.defaultList.modelData && this.defaultList.modelData.MainList && this.defaultList.modelData.MainList.DetailList),
                    detailListCount: (this.defaultList && this.defaultList.modelData && this.defaultList.modelData.MainList && this.defaultList.modelData.MainList.DetailList) ? this.defaultList.modelData.MainList.DetailList.length : 0
                });
                Promise.resolve().then(() => this.defaultList.ClearSearch());
                if (selectedItem){
                    this.tabsContainerService.EmitItem(selectedItem);
                }
            }

            if (activeTab === 'tbUpdate') {
                this.baseTabsUpdate.focus();
                // setTimeout(() => {
                //     this.baseTabsUpdate?.refreshSavedState?.();
                // });
            }
        });
    }
        
    SelectList(){
        this.tabsContainerService.ShowList();
    }

    //AddItem(){
        //this.tabsContainerService.ShowUpdate();
    //}
}
